import React, { useEffect, useState }  from 'react';
import Popup from "reactjs-popup";
import "react-table/react-table.css";
import auth from '../../../service/Auth';
import '../../../../index.js';
import {experiment_status,experiment_information} from '../../../service/apis';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import { Redirect } from 'react-router-dom';
import BrowseButtons from './components/BrowseButtons';
import ExperimentInformationHeader from './components/ExperimentInformationHeader';
import ExperimentInformationMainFrame from './components/ExperimentInformationMainFrame';
import AnalysisTimeLine from './components/AnalysisTimeLine';
import { GPAP_Button_Orange } from '../../../../gpap-lib/Button_Collection';

import "./experiment-info.css"

const config = window.config;


const ExperimentInfo = (props) => {

    const [popupErrors, setPopupErrors] = useState("");
    const [ExperimentStatus, setExperimentStatus] = useState("");
    const [ExperimentInformation, setExperimentInformation] = useState("");
    const [ExperimentID, setExperimentID] = useState("");
    const [loading, setLoading] =  useState(true);
    const [goToExperiments, setGoToExperiments] = useState(false);


    const fetchExperimentInformation = async () => { 
        // Experiment Information api request data
        await experiment_information(auth.getToken(),config.api_endpoint,props.match.params.experiment_id)
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            if (typeof data === "string") {
                setPopupErrors(data);
            } else {
                setExperimentInformation(data);
            }
            setLoading(false);
        })
    }

    const fetchExperimentStatus = async () => {
        // Experiment Status api request data
        await experiment_status(auth.getToken(),config.api_endpoint,props.match.params.experiment_id)
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            setExperimentStatus(data);
            setLoading(false);
        })
    }

    // On load for the first time
    useEffect(() => {
        if (auth.tokenExpired()) {
            // Logging check
            setPopupErrors("Logging session timeout. Please log again");
        }
        else{
            // Set Experiment ID
            setExperimentID(props.match.params.experiment_id);
            // Fetch Experiment Information and Experiment status
            fetchExperimentInformation();
            fetchExperimentStatus();
        }
    },[])

    const close = () => {
        setPopupErrors("");
        setGoToExperiments(true);
    }

    const divStyle = {
        padding: "10px",
        fontFamily: "Trebuchet MS, Helvetica, sans-serif"
    };

    // Go to Experiments View 
    if (goToExperiments){
        return <Redirect to={{pathname:'/experiments'}}/>;
    }

    // Check popup errors
    if (popupErrors) {
        return (
            <Popup open={true} onClose={close}>
                <div>
                    <div className="page-header"> <h1> Sorry!! </h1> </div>
                    <div className="alert alert-warning"> {popupErrors} </div>
                    <GPAP_Button_Orange startIcon={<ArrowBackIcon />}  onClick={close}> CLOSE </GPAP_Button_Orange>
                </div>
            </Popup>
        );
    }

    return(
        <div className={"mainContent"}>
            <div style={divStyle}>
                {/* Browse Buttons for going Back and go to Phenostore */}
                <BrowseButtons ExperimentInformation={ExperimentInformation}/>
                {/* Experiment Information Header*/}
                <Grid container justifyContent={"center"}>
                    <ExperimentInformationHeader ExperimentID={ExperimentID} Owner={ExperimentInformation.Owner} />
                    <Divider/>
                    <Grid item lg={5}>
                        {/* Experiment Data in View main frame*/}
                        <ExperimentInformationMainFrame ExperimentInformation={ExperimentInformation} />
                    </Grid>
                    <Grid item={2}>
                        {/* Analysis Time Line */}
                        <AnalysisTimeLine ExperimentStatus={ExperimentStatus}
                                          ExperimentInformation={ExperimentInformation}
                        />
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}

export default ExperimentInfo;
